import { getMatchChar, getMatchStringRegExp } from "./regexp";
function toMarkValue(value, filter) {
    const subString = filter?.strict
        ? getMatchStringRegExp(filter.match)
        : new RegExp(filter.match, "gi");
    const css = filter?.strict ? "wx-todo_filter--strict" : "wx-todo_filter";
    return value.replace(subString, match => {
        return `<mark class="${css}">${match}</mark>`;
    });
}
function toTagValue(value) {
    return value.replace(getMatchChar("#"), match => {
        return `<span class="wx-todo_tag" data-tag="${match}">${match}</span>`;
    });
}
function toDateValue(value) {
    const subString = new RegExp(/!\((.+?)\)/gm);
    return value.replace(subString, match => {
        const matchString = match.substring(2, match.length - 1);
        return `<span class="wx-todo_date" data-date="${matchString}">${matchString}</span>`;
    });
}
export function htmlEscapes(value) {
    const code = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        // "'": "&#39;", //TODO: fix for single quotes
    };
    return value.replace(/[&<>"]/g, match => {
        return code[match];
    });
}
export function getTransformValue(value, filter) {
    if (!value) {
        return "";
    }
    let transformValue = htmlEscapes(value);
    if (filter?.highlight) {
        transformValue = toMarkValue(transformValue, filter);
    }
    else {
        transformValue = toTagValue(transformValue);
        transformValue = toDateValue(transformValue);
    }
    return transformValue;
}
export function getCountLabel(name, array, locale) {
    const matchProjects = array.filter(p => p.label.includes(locale(name)));
    if (!matchProjects.length)
        return locale(name);
    const number = new RegExp(/\d+(?=\))/gm);
    let level = 0;
    for (const { label } of matchProjects) {
        const match = label.match(number);
        if (match && +match[0] > level)
            level = +match[0];
    }
    return `${locale(name)} (${level + 1})`;
}
//# sourceMappingURL=text.js.map